// Formato argentino unico para importes y distancias en toda la web de Cyker.
// Igual que la app (Pesos.conEspacio) y la pantalla del auto: "$ 8.900", "7,33 km".
// Separador de miles a mano: el WebView de Android ignora toLocaleString('es-AR').

export const pesos = (v) => (v == null || v === '' || isNaN(Number(v)))
  ? '—'
  : '$ ' + String(Math.round(Number(v))).replace(/\B(?=(\d{3})+(?!\d))/g, '.');

/** Metros -> "7,33" (sin la unidad, para poner "km" al lado) */
export const numKm = (metros) => ((parseFloat(metros) || 0) / 1000).toFixed(2).replace('.', ',');

/** "nati mego" -> "Nati Mego" (los nombres se cargan como los escribe cada uno) */
export const nombrePropio = (s) => String(s || '').trim().toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase());

/** -1.5634 -> "−1,56 %" */
export const pctTxt = (n) => (n >= 0 ? '+' : '−') + Math.abs(n).toFixed(2).replace('.', ',') + ' %';

/** Viaje terminado -> su ticket; en curso -> la pagina del viaje en vivo (historial y turno del dueno) */
export const enlaceViaje = (v) => (v && v.qr_token
  ? ((v.fin || v.estado === 'finalizado')
    ? `https://cyker.satelitax.com.ar/api/viajes/qr/${encodeURIComponent(v.qr_token)}/ticket`
    : `/viaje/${encodeURIComponent(v.qr_token)}`)
  : undefined);
